import { config } from '@/config';
export const dockerFromUser = (userId) => {
    return `${userId}-${config.value.env.environment}`;
};
